// Campaigns Edit - Alpine.js Component
// Handles campaign editing with form validation and date pickers

import flatpickr from "flatpickr";

document.addEventListener('alpine:init', () => {

    Alpine.data('campaigns_edit_x_data', () => ({
        // Form data properties
        campaign_name: '',
        campaign_primary_goal: '',
        campaign_targeting_parameters: '',
        campaign_budget: null,
        campaign_start_date: '',
        campaign_end_date: '',

        init() {
            // Load existing campaign data
            this.loadCampaignData();
            
            // Initialize Flatpickr for start date
            this.startDatePicker = flatpickr("#campaign_start_date", {
                dateFormat: "Y-m-d",
                minDate: "today",
                onChange: (selectedDates, dateStr) => {
                    this.campaign_start_date = dateStr;
                    // Update end date min date to be after start date
                    if (this.endDatePicker) {
                        this.endDatePicker.set('minDate', dateStr);
                    }
                }
            });
            
            // Initialize Flatpickr for end date
            this.endDatePicker = flatpickr("#campaign_end_date", {
                dateFormat: "Y-m-d",
                minDate: "today",
                onChange: (selectedDates, dateStr) => {
                    this.campaign_end_date = dateStr;
                }
            });
            
            // Watch for changes to campaign_budget and ensure it's a whole number
            this.$watch('campaign_budget', (value) => {
                if (value !== null && value !== '') {
                    const numericValue = parseFloat(value);
                    if (!isNaN(numericValue) && numericValue !== Math.floor(numericValue)) {
                        this.campaign_budget = Math.floor(numericValue);
                    }
                }
            });
        },

        loadCampaignData() {
            // Load campaign name
            const nameInput = document.querySelector('input[name="campaign[name]"]');
            if (nameInput && nameInput.value) {
                this.campaign_name = nameInput.value;
            }

            // Load campaign budget
            const budgetInput = document.querySelector('input[name="campaign[budget]"]');
            if (budgetInput && budgetInput.value) {
                this.campaign_budget = parseFloat(budgetInput.value);
            }

            // Load start date
            const startDateInput = document.querySelector('input[name="campaign[start_date]"]');
            if (startDateInput && startDateInput.value) {
                this.campaign_start_date = startDateInput.value;
                // Update the date picker
                if (this.startDatePicker) {
                    this.startDatePicker.setDate(startDateInput.value);
                }
            }

            // Load end date
            const endDateInput = document.querySelector('input[name="campaign[end_date]"]');
            if (endDateInput && endDateInput.value) {
                this.campaign_end_date = endDateInput.value;
                // Update the date picker
                if (this.endDatePicker) {
                    this.endDatePicker.setDate(endDateInput.value);
                }
            }

            // Load campaign survey data from hidden field if it exists
            const existingSurveyField = document.getElementById('existing_campaign_survey');
            if (existingSurveyField && existingSurveyField.value) {
                try {
                    const surveyData = JSON.parse(existingSurveyField.value);
                    if (surveyData.primary_goal) {
                        this.campaign_primary_goal = surveyData.primary_goal;
                    }
                    if (surveyData.targeting_parameters) {
                        this.campaign_targeting_parameters = surveyData.targeting_parameters;
                    }
                } catch (error) {
                    console.error('Error parsing existing campaign survey data:', error);
                }
            }

            // Set radio button values
            this.$nextTick(() => {
                // Set primary goal radio button
                if (this.campaign_primary_goal) {
                    const primaryGoalRadio = document.querySelector(`input[name="primary_goal"][value="${this.campaign_primary_goal}"]`);
                    if (primaryGoalRadio) {
                        primaryGoalRadio.checked = true;
                    }
                }

                // Set targeting parameters radio button
                if (this.campaign_targeting_parameters) {
                    const targetingRadio = document.querySelector(`input[name="targeting_parameters"][value="${this.campaign_targeting_parameters}"]`);
                    if (targetingRadio) {
                        targetingRadio.checked = true;
                    }
                }
            });
        },

        validate_campaign_form(action_type) {
            if (action_type === 'draft') {
                // Only require campaign name for draft
                if (!this.campaign_name || this.campaign_name.trim() === '') {
                    alert('Campaign name is required to save as draft.');
                    return false;
                }
                // For draft, if budget is provided, it must meet minimum
                if (this.campaign_budget && this.campaign_budget < 1000) {
                    alert('Campaign budget must be at least $1000.');
                    return false;
                }
            } else if (action_type === 'next') {
                // Require all fields for next
                if (!this.campaign_name || this.campaign_name.trim() === '') {
                    alert('Campaign name is required.');
                    return false;
                }
                if (!this.campaign_primary_goal || this.campaign_primary_goal === '') {
                    alert('Please select your primary goal.');
                    return false;
                }
                if (!this.campaign_targeting_parameters || this.campaign_targeting_parameters === '') {
                    alert('Please select your targeting parameters.');
                    return false;
                }
                if (!this.campaign_budget || this.campaign_budget < 1000) {
                    alert('Campaign budget must be at least $1000.');
                    return false;
                }
                if (!this.campaign_start_date || this.campaign_start_date === '') {
                    alert('Start date is required.');
                    return false;
                }
                if (!this.campaign_end_date || this.campaign_end_date === '') {
                    alert('End date is required.');
                    return false;
                }
                if (new Date(this.campaign_start_date) >= new Date(this.campaign_end_date)) {
                    alert('End date must be after start date.');
                    return false;
                }
            }

            return true;
        },

        submit_campaign_form(action_type, event = null) {
            // Prevent default form submission if event is provided
            if (event) {
                event.preventDefault();
            }

            // Validate form first
            if (!this.validate_campaign_form(action_type)) {
                return false;
            }

            // Set submission type in hidden field
            document.getElementById('submission_type').value = action_type;

            // Collect survey data
            const surveyData = {
                primary_goal: this.campaign_primary_goal,
                targeting_parameters: this.campaign_targeting_parameters
            };

            document.getElementById('campaign_survey_data').value = JSON.stringify(surveyData);

            document.getElementById('campaign-form').submit();
            return false; // Prevent any additional form submission
        },
    }));

});
